import { MetronomeTickIcon } from './MetronomeTickIcon';

/**
 * author: Haley Halcyon
 * id 43A2B10E-F7DF-4181-B607-EC2039AFFA0D
 * name metronome-tick
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/metronome-tick.svg
 * tags
 * - Music 
 */
export const BeatsPerMinuteTickIcon = MetronomeTickIcon;
export default BeatsPerMinuteTickIcon